/**
 * Copyright 2020 ForgeRock AS. All Rights Reserved
 *
 * Use of this code requires a commercial software license with ForgeRock AS.
 * or with one of its affiliates. All use shall be exclusively subject
 * to such license between the licensee and ForgeRock AS.
 */
import { generateAmApi, generateIdmApi } from './BaseApi';

const amInfoApi = {
  path: '',
  apiVersion: 'protocol=2.1,resource=1.0',
};
let idmURL;
const locationUrl = window.location.origin;
if (locationUrl.indexOf('dev.account.ct.gov') > 0) {
  idmURL = 'https://dev.account.ct.gov/openidm';
} else if (locationUrl.indexOf('devc.account.ct.gov') > 0) {
  idmURL = 'https://devc.account.ct.gov/openidm';
} else if (locationUrl.indexOf('stg.account.ct.gov') > 0) {
  idmURL = 'https://stg.account.ct.gov/openidm';
} else if (locationUrl.indexOf('psup.account.ct.gov') > 0) {
  idmURL = 'https://psup.account.ct.gov/openidm';
} else if (locationUrl.indexOf('account.ct.gov') > 0) {
  idmURL = 'https://account.ct.gov/openidm';
}
const idmInfoApi = {
  baseURL: idmURL,
};

/**
  * Gets server info including iPlanetDirectoryPro cookie name
  * @returns {Promise}
  */
export function getAmServerInfo(realm) {
  if (realm && realm !== 'root' && realm !== '/') {
    return generateAmApi({
      path: `realms/root/realms/${realm}`,
      apiVersion: 'protocol=2.1,resource=1.0',
    }).get(
      'serverinfo/*',
      { withCredentials: true },
    );
  }

  return generateAmApi(amInfoApi).get(
    'serverinfo/*',
    { withCredentials: true },
  );
}

export function getIdmServerInfo() {
  return generateIdmApi(idmInfoApi).get(
    'info/version',
  );
}
